import { type ApiResponse, ApiFactory } from '@/utils/api'
import type {
  BaseAddGoodsInfoType,
  BaseEditGoodsInfoType,
  AddGoodsInSelectionsReqType
} from '@/models/types/goods.types'
import { GoodsEnums } from '@/constants/enums/api/goods.enum'

export class GoodsServices extends ApiFactory {
  constructor() {
    super('')
  }

  /* 編輯商品 */
  edit = async (params: BaseEditGoodsInfoType): Promise<ApiResponse> => {
    return await this.put<unknown, ApiResponse>(GoodsEnums.edit, params)
  }

  /* 編輯商品-其他業主商品池 */
  editGoodsOnOtherPool = async (params: BaseEditGoodsInfoType): Promise<ApiResponse> => {
    return await this.put<unknown, ApiResponse>(GoodsEnums.editGoodsOnOtherPool, params)
  }

  /* 建立商品 */
  add = async (params: BaseAddGoodsInfoType): Promise<ApiResponse> => {
    return await this.post<unknown, ApiResponse>(GoodsEnums.add, params)
  }

  /* 建立商品-其他業主商品池 */
  addGoodsOnOtherPool = async (params: BaseAddGoodsInfoType): Promise<ApiResponse> => {
    return await this.post<unknown, ApiResponse>(GoodsEnums.addGoodsOnOtherPool, params)
  }

  /* 快速新增商品（更換商品彈窗） */
  addGoodsInSelections = async (params: AddGoodsInSelectionsReqType): Promise<ApiResponse> => {
    return await this.post<unknown, ApiResponse>(GoodsEnums.addGoodsInSelections, params)
  }

  /* 刪除商品 */
  delete = async <Response = ApiResponse>(params: string): Promise<Response> => {
    return await super.put<unknown, Response>(GoodsEnums.delete, params)
  }

  /* 刪除商品-其他業主商品池 */
  deleteOnOtherPool = async <Response = ApiResponse>(params: string): Promise<Response> => {
    return await super.put<unknown, Response>(GoodsEnums.deleteOnOtherPool, params)
  }

  /* 商品營運數據清單 */
  operationInfo = async (params: string): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(GoodsEnums.info, { input: params })
  }

  /* 商品營運數據清單-其他業主商品池 */
  operationInfoOnOtherPool = async (params: string): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(GoodsEnums.infoOnOtherPool, { input: params })
  }

  /* 商品營運數據圖表 */
  operationInfoChart = async (params: {
    startDate: string
    endDate: string
    goodsId: string
  }): Promise<ApiResponse> => {
    return await this.get<unknown, ApiResponse>(GoodsEnums.chart, params)
  }
}
